import { motion } from "framer-motion";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

// Icons
import Systolic from "../../../../assets/img/blood-pressure.svg";
import Diastolic from "../../../../assets/img/blood-pressure-check.svg";
import Weight from "../../../../assets/img/sport.png";
import AdmissionWeight from "../../../../assets/img/weight-loss.png";
import Height from "../../../../assets/img/height.svg";
import Temperature from "../../../../assets/img/icons/temp.svg";
import Oxygen from "../../../../assets/img/oxygen-saturation.svg";
import BirthWeight from "../../../../assets/img/bathroom-scale.png";
import Respiratory from "../../../../assets/img/respiratory-system.svg";
import Pulse from "../../../../assets/img/pulse.svg";
import Menstrual from "../../../../assets/img/icons/menstrual-cycle.svg";
import Intensivist from "../../../../assets/img/icons/intensivist.svg";
import Ventilation from "../../../../assets/img/icons/ventilation.svg";
import LengthStay from "../../../../assets/img/icons/time.svg";

const ClaimProviderVitalSign = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const preauthVitalSign = viewClaimInfo?.payload_json?.sup_info || {};

  const vitalSignInfo = Object.values(preauthVitalSign);

  const systolic = vitalSignInfo?.find((item) => item?.systlc)?.systlc || "";
  const diastolic = vitalSignInfo?.find((item) => item?.diastlc)?.diastlc || "";
  const weight = vitalSignInfo?.find((item) => item?.wgt)?.wgt || "";
  const admissionweight =
    vitalSignInfo?.find((item) => item?.admnwgt)?.admnwgt || "";
  const height = vitalSignInfo?.find((item) => item?.hgt)?.hgt || "";
  const temperature = vitalSignInfo?.find((item) => item?.temp)?.temp || "";
  const oxygen = vitalSignInfo?.find((item) => item?.oxystrn)?.oxystrn || "";
  const birthweight =
    vitalSignInfo?.find((item) => item?.brthwgt)?.brthwgt || "";
  const respiratoryrate =
    vitalSignInfo?.find((item) => item?.resprte)?.resprte || "";
  const pulse = vitalSignInfo?.find((item) => item?.plse)?.plse || "";
  const menstrualperiod =
    vitalSignInfo?.find((item) => item?.menstprd)?.menstprd || "";
  const icuhours = vitalSignInfo?.find((item) => item?.icuhrs)?.icuhrs || "";
  const ventilationhours =
    vitalSignInfo?.find((item) => item?.vnthrs)?.vnthrs || "";
  const lengthofstay =
    vitalSignInfo?.find((item) => item?.lgthsty)?.lgthsty || "";
  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Vital Sign</span>
        </span>
      </div>

      <Row className="mt-3">
        {/* Systolic */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Systolic B.P"
            imageSrc={Systolic}
            bg="badge-subtle-danger"
            value={systolic ? `${systolic} mmHg` : ""}
          />
        </Col>

        {/* Diastolic */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Diastolic B.P"
            imageSrc={Diastolic}
            bg="badge-subtle-warning"
            value={diastolic ? `${diastolic} mmHg` : ""}
          />
        </Col>

        {/* Weight */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Weight"
            imageSrc={Weight}
            bg="badge-subtle-success"
            value={weight ? `${weight} kg` : ""}
          />
        </Col>

        {/* Admission Weight */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Admission Weight"
            imageSrc={AdmissionWeight}
            bg="badge-subtle-success"
            value={admissionweight ? `${admissionweight} kg` : ""}
          />
        </Col>

        {/* Height */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Height"
            imageSrc={Height}
            bg="badge-subtle-secondary"
            value={height ? `${height} cm` : ""}
          />
        </Col>

        {/* Temperature */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Temperature"
            imageSrc={Temperature}
            bg="badge-subtle-primary"
            value={temperature ? `${temperature} °C` : ""}
          />
        </Col>

        {/* Oxygen */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="O2 Saturation"
            imageSrc={Oxygen}
            bg="badge-subtle-info"
            value={oxygen ? `${oxygen} %` : ""}
          />
        </Col>

        {/* Birth Weight */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Birth Weight"
            imageSrc={BirthWeight}
            bg="badge-subtle-danger"
            value={birthweight ? `${birthweight} kg` : ""}
          />
        </Col>

        {/* Respiratory Rate */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Respiratory Rate"
            imageSrc={Respiratory}
            bg="badge-subtle-success"
            value={respiratoryrate ? `${respiratoryrate} rpm` : ""}
          />
        </Col>

        {/* Pulse */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Pulse"
            imageSrc={Pulse}
            bg="badge-subtle-secondary"
            value={pulse ? `${pulse} bpm` : ""}
          />
        </Col>

        {/* Menstrual Period */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Last Menstrual Period"
            imageSrc={Menstrual}
            bg="badge-subtle-primary"
            value={menstrualperiod}
          />
        </Col>

        {/* ICU Hours */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="ICU Hours"
            imageSrc={Intensivist}
            bg="badge-subtle-info"
            value={icuhours ? `${icuhours} h` : ""}
          />
        </Col>

        {/* Ventilation Hours */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Ventilation Hours"
            imageSrc={Ventilation}
            bg="badge-subtle-primary"
            value={ventilationhours ? `${ventilationhours} h` : ""}
          />
        </Col>

        {/* Length of Stay */}
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Estimated Length of Stay"
            imageSrc={LengthStay}
            bg="badge-subtle-secondary"
            value={lengthofstay ? `${lengthofstay} days` : ""}
          />
        </Col>
      </Row>
    </motion.div>
  );
};

export default ClaimProviderVitalSign;

// --------------------------
// VitalSignItem Component
// --------------------------

const VitalSignItem = ({ title, value, imageSrc, bg }) => {
  return (
    <Card className="p-3">
      <div className="d-flex justify-content-between align-items-center">
        {/* Icon */}
        <div
          style={{ borderRadius: "10px", padding: "8px" }}
          className={`d-flex align-items-center justify-content-center ${bg}`}
        >
          <img
            src={imageSrc}
            style={{ width: "30px", height: "30px" }}
            alt="icon"
          />
        </div>

        {/* Text */}
        <div className="d-flex flex-column gap-1 text-end">
          <span className="fw-normal fs-10">{title}</span>
          <span className="fw-bolder text-400 fs-9">{value}</span>
        </div>
      </div>
    </Card>
  );
};
